import { SurveyResultView, SurveyView } from '../../backend/backendapi';

export function getSignatureImage(survey: SurveyView, result: SurveyResultView): string {
    const model = JSON.parse(survey?.json ?? '{}');
    const signatureQuestions = (model.pages ?? [])
        .map(p => p.elements?.filter(e => e.type === 'signaturepad').map(e => e.name))
        .reduce((l, r) => l.concat(r), []);
    if (!signatureQuestions.length) {
        return '';
    }

    const resultModel = JSON.parse(result?.jsonResult ?? '{}');
    const resultSignatures = Object.keys(resultModel).filter(e => signatureQuestions.includes(e));
    if (!resultSignatures.length) {
        return '';
    }

    return resultModel[resultSignatures[0]];
}